import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { CategorySelection } from '../../../models/api.model'
import { GlobalConstants } from '../../../constants/global-constants'

@Component({
  selector: 'app-category-selector',
  templateUrl: './category-selector.component.html',
  styleUrls: ['./category-selector.component.scss']
})
export class CategorySelectorComponent implements OnInit {
  @Input() module: string
  @Input() showSubcategorySelector: boolean = true
  @Output() categorySelectorEvent: EventEmitter<CategorySelection> = new EventEmitter<CategorySelection>()
  selectedCategory = ''
  categorySubcategoryMap: Map<string, string[]> = new Map()

  constructor(private appState: Store<AppState>) {
  }

  ngOnInit(): void {
    this.appState.select('initialize').subscribe(({ taskTypes }) => {
      if (taskTypes) {
        for (let [category, subCategoryData] of Object.entries(taskTypes)) {
          let subCategoryArr: string[] = []
          let customCategory: string = ''
          for (const subCategory of Object.keys(subCategoryData)) {
            if (this.module !== 'NA') {
              const moduleData = subCategoryData[subCategory]
              for (const module of Object.keys(moduleData)) {
                if (!subCategoryArr.includes(subCategory)) {
                  const taskType = taskTypes[category][subCategory][this.module]
                  if (Array.isArray(taskType)) {
                    const isCreatableByEmployee = taskType.some(task => task && task.creatableByEmployee)
                    if (isCreatableByEmployee) {
                      subCategoryArr.push(subCategory)
                    }
                  }
                }
              }
            } else { //custom categorization for knowledge article
              // Labour and Other LLC reduced to single category as LLC
              customCategory = category.replace(GlobalConstants.CATEGORY_TYPE.OTHER_LLC, GlobalConstants.CATEGORY_TYPE.LLC)
              if (subCategory) {
                customCategory = (subCategory === GlobalConstants.CATEGORY_TYPE.LABOUR ? GlobalConstants.CATEGORY_TYPE.LLC : customCategory)
              }
              const moduleData = subCategoryData[subCategory]
              for (const module of Object.keys(moduleData)) {
                if (!subCategoryArr.includes(subCategory)) {
                  const taskType = taskTypes[category][subCategory][module]
                  if (Array.isArray(taskType)) {
                    const isCreatableByEmployee = taskType.some(task => task && task.creatableByEmployee)
                    if (isCreatableByEmployee) {
                      subCategoryArr.push(subCategory)
                    }
                  }
                }
              }
              if (customCategory === GlobalConstants.CATEGORY_TYPE.LLC) {
                let existingLLCSubCategories = this.categorySubcategoryMap.get(customCategory) || []
                const combinedSubCategories = new Set([...subCategoryArr, ...existingLLCSubCategories])
                subCategoryArr = Array.from(combinedSubCategories)
              }
            }
          }
          if (customCategory)
            category = customCategory

          if (subCategoryArr.length > 0) {
            this.categorySubcategoryMap.set(category, subCategoryArr)
          }
        }
      }

      this.selectedCategory = Array.from(this.categorySubcategoryMap?.keys())?.sort()?.at(0) || ''
      if (this.selectedCategory !== '') {
        const categorySelection: CategorySelection = {
          selectedCategory: this.selectedCategory,
          selectedSubCategory: this.categorySubcategoryMap?.get(this.selectedCategory)?.at(0) || ''
        }
        this.categorySelectorEvent.emit(categorySelection)
      }
    })
  }

  selectCategory(selectedCategory: string) {
    this.selectedCategory = selectedCategory
    const categorySelection: CategorySelection = {
      selectedCategory: this.selectedCategory,
      selectedSubCategory: this.categorySubcategoryMap?.get(this.selectedCategory)?.at(0) || ''
    }
    if (!this.showSubcategorySelector || !this.showSubCategoryDropdown()) {
      this.categorySelectorEvent.emit(categorySelection)
    }
  }

  swapCategory(array, index1, index2) {
    array[index1] = array.splice(index2, 1, array[index1])[0]
  }

  showSubCategoryDropdown(): boolean {
    if (this.selectedCategory) {
      const subCategories = this.categorySubcategoryMap?.get(this.selectedCategory)
      if (subCategories) {
        const uniqueSubcategories = new Set(subCategories)
        return !(uniqueSubcategories.size === 1 && uniqueSubcategories.has(this.selectedCategory))
      }
    }
    return false
  }

  selectSubCategory(selectedSubCategory: string) {
    if (selectedSubCategory && this.showSubCategoryDropdown()) {
      const categorySelection: CategorySelection = {
        selectedCategory: this.selectedCategory,
        selectedSubCategory: selectedSubCategory
      }
      this.categorySelectorEvent.emit(categorySelection)
    }
  }
}
